var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rundgang"},[(!_vm.modalState)?_c('div',{staticClass:"content-container mp-container"},[_c('div',{staticClass:"main"},[_c('Plan')],1)]):_vm._e(),_c('div',{staticClass:"aside-right"},[_c('DetailList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }